/* NEW: UI_REVAMP */
import React from 'react';
import { Text } from '@chakra-ui/react';
import { RECORD_GRADIENTS } from '../../styles/recordUiTokens';

const GradientText = ({ children, gradient = RECORD_GRADIENTS.greenText, sx, ...props }) => {
	return (
		<Text
			bgGradient={gradient}
			bgClip='text'
			sx={{ WebkitTextFillColor: 'transparent', ...sx }}
			display='inline-block'
			{...props}
		>
			{children}
		</Text>
	);
};

export default GradientText;
